import { useMsal } from '@azure/msal-react';
import posthog from 'posthog-js';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { TableName } from '../../constants/table';
import { getEntity } from '../services/api-service';
import TenantContext from './TenantContext';

// Define the shape of the user object
interface User {
  id: number;
  name: string;
  email: string;
  roles: string[];
}

// Create the initial user object
const initialUser: User = {
  id: 0,
  name: '',
  email: '',
  roles: [],
};

// Create the user context
export const UserContext = createContext<User>(initialUser);

// Create the user provider component
export const UserProvider = (props: { children: React.ReactNode }) => {
  const { accounts } = useMsal();
  const { tenant } = useContext(TenantContext);
  const [user, setUser] = useState<User>(initialUser);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const tenantId = tenant?.id;
        const userEmail = accounts?.[0]?.username.toLowerCase();
        console.log('Fetching user role for:', userEmail);
        if (tenantId && userEmail) {
          const userEntity = await getEntity(
            TableName.Users,
            tenantId,
            userEmail.toLowerCase(),
          );

          if (userEntity && typeof userEntity.Role === 'string') {
            setUser({
              email: userEntity.Email,
              id: userEntity.Id,
              name: userEntity.Name,
              roles: [userEntity.Role],
            });
            if (accounts) {
              posthog.identify(accounts[0]?.homeAccountId ?? '', {
                email: userEmail || '',
                name: accounts[0]?.name || '',
                tenantId: tenant?.id,
              });
              console.log('User identified in PostHog:', userEmail);
            }
          }
        }
      } catch (error) {
        // Handle error
      }
    };

    fetchUserRole();
  }, [accounts, tenant]);

  return (
    <UserContext.Provider value={user}>{props.children}</UserContext.Provider>
  );
};
